export default __webpack_public_path__ + "static/media/CASSIE_Projeto.3d3b569c.png";